<a class="link-container" [href]="link">
  <div class="link-container__left">
    <i class="pi pi-file-o"></i>
    <span>{{ label }}</span>
  </div>
  <i class="pi icon-arrow-right"></i>
</a>
